var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalien(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4381 2.323C23.786 2.1193 24.2146 2.1193 24.5626 2.323L34.7997 8.31652C35.1476 8.52022 35.362 8.89667 35.362 9.30407V21.2911C35.362 21.6985 35.1476 22.075 34.7997 22.2787L24.5626 28.2722C24.2146 28.4759 23.786 28.4759 23.4381 28.2722L13.2009 22.2787C12.853 22.075 12.6387 21.6985 12.6387 21.2911V9.30407C12.6387 8.89667 12.853 8.52022 13.2009 8.31652L23.4381 2.323Z",
    stroke: "#871C6A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6483 26.9501L27.541 40.9625L20.4584 40.9625L21.3511 26.9501",
    stroke: "#871C6A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4016 41.8419C17.4625 41.3399 17.8887 40.9623 18.3944 40.9623H29.607C30.1127 40.9623 30.5389 41.3399 30.5997 41.842L31.0833 45.8298H16.918L17.4016 41.8419Z",
    stroke: "#871C6A",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalien);
export default __webpack_public_path__ + "static/media/galien.63246917b6f3424a8fbd63c052977090.svg";
export { ForwardRef as ReactComponent };